import * as z from "zod";

const schema = z.object({
	id: z.string().nullable(),
	name: z.string().nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const ManagerInformationModel = {schema, model};
export type IManagerInformationModel = z.infer<typeof ManagerInformationModel.model>;
export const DEFAULT_MANAGER_INFORMATION: IManagerInformationModel = {
	id: null,
	name: null
};
